export default __webpack_public_path__ + "static/media/hearing.4cce82ab.svg";